import { TFunction } from "i18next";
import { MD3Theme } from "react-native-paper";
import { ComponentType } from "react";
import { TextStyle } from "react-native";
import { Field } from "../../../config/companies/config";

export type MediaViewerItem = {
  uri: string;
  name?: string;
  mimeType?: string;
};

export type FieldDisplayRendererProps = {
  field: Field;
  value: any;
  onChange?: (fieldName: string, newValue: any) => void;
  item?: any;
  valueStyle?: TextStyle;
  showFileName?: boolean;
  t: TFunction;
  theme: MD3Theme;
  openMediaViewer: (media: MediaViewerItem) => void;
};

export type FieldDisplayRendererComponent =
  ComponentType<FieldDisplayRendererProps>;
